import React, { useState, useEffect, useRef, useCallback } from "react";
import DevDataService from "../services/DevService";
import { useParams, useNavigate } from 'react-router-dom';
import TransactionTable from "../../components/TransactionTable";

const DevPr = (props) => {
  const [dev, setDev] = useState([]);
  const devRef = useRef();
  devRef.current = dev;

  const { owner } = useParams();
  const navigate = useNavigate();

  const retrieveDev = useCallback((ownerParam) => {
    const target = ownerParam ?? owner;
    DevDataService.getAll(target)
      .then((response) => setDev(response.data || []))
      .catch((e) => { console.error(e); setDev([]); });
  }, [owner]);

  useEffect(() => { retrieveDev(); }, [retrieveDev]);

  const deleteDev = useCallback((rowIndex) => {
    const id = devRef.current[rowIndex].id || devRef.current[rowIndex]._id;
    DevDataService.remove(id)
      .then(() => {
        const newDev = [...devRef.current];
        newDev.splice(rowIndex, 1);
        setDev(newDev);
      })
      .catch((e) => console.error(e));
  }, []);

  const handleView = useCallback((row) => {
    const id = row.id || row._id;
    if (id) navigate(`/dashboard/dev/${id}`);
  }, [navigate]);

  const handleEdit = useCallback((row) => {
    const id = row.id || row._id;
    if (id) navigate(`/dashboard/dev/edit/${id}`);
  }, [navigate]);

  const handleDeleteRow = useCallback((row) => {
    const idx = devRef.current.findIndex(item => (item.id || item._id) === (row.id || row._id));
    if (idx >= 0) deleteDev(idx);
  }, [deleteDev]);

  return (
    <div className="list row">
      <div className="col-md-12 list">
        <TransactionTable
          transactions={dev}
          onView={handleView}
          onEdit={handleEdit}
          onDelete={handleDeleteRow}
          initialPageSize={10}
          showBack={true}
          onBack={() => navigate(-1)}
        />
      </div>
    </div>
  );
};

export default DevPr;
